var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7923 39.2491L31.5715 28.9995L49.7923 18.7499C50.0711 18.5797 50.273 18.308 50.3555 17.9919C50.438 17.6758 50.3946 17.3401 50.2344 17.0554C50.0742 16.7707 49.8098 16.5593 49.4969 16.4656C49.1839 16.372 48.8468 16.4035 48.5566 16.5534L30.2614 26.8447V6.30384C30.2614 5.96943 30.1286 5.64873 29.8921 5.41227C29.6557 5.17581 29.335 5.04297 29.0006 5.04297C28.6661 5.04297 28.3454 5.17581 28.109 5.41227C27.8725 5.64873 27.7397 5.96943 27.7397 6.30384V26.8447L9.44446 16.5534C9.15426 16.4035 8.81719 16.372 8.50424 16.4656C8.19128 16.5593 7.92688 16.7707 7.76672 17.0554C7.60656 17.3401 7.56313 17.6758 7.6456 17.9919C7.72806 18.308 7.92998 18.5797 8.20881 18.7499L26.4296 28.9995L8.20881 39.2491C7.96623 39.3859 7.77578 39.5992 7.66718 39.8557C7.55859 40.1121 7.53796 40.3973 7.60852 40.6668C7.67908 40.9362 7.83685 41.1747 8.05722 41.345C8.27758 41.5153 8.54813 41.6078 8.82664 41.6082C9.0428 41.6085 9.25532 41.5524 9.4432 41.4455L27.7397 31.1543V51.6951C27.7397 52.0295 27.8725 52.3503 28.109 52.5867C28.3454 52.8232 28.6661 52.956 29.0006 52.956C29.335 52.956 29.6557 52.8232 29.8921 52.5867C30.1286 52.3503 30.2614 52.0295 30.2614 51.6951V31.1543L48.5566 41.4455C48.7449 41.5526 48.9579 41.6087 49.1745 41.6082C49.4531 41.6081 49.7238 41.5157 49.9444 41.3455C50.165 41.1753 50.323 40.9368 50.3937 40.6674C50.4644 40.3979 50.4439 40.1126 50.3353 39.856C50.2267 39.5994 50.035 39.386 49.7923 39.2491Z",
    fill: "url(#paint0_linear_743_3988)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 10.6953,
    y: 10.6953,
    width: 36.6086,
    height: 36.6089
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_0_743_3988_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_743_3988)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 35.304C27.7528 35.304 26.5339 34.9343 25.4972 34.2415C24.4604 33.5488 23.6524 32.5642 23.1752 31.4122C22.698 30.2603 22.5732 28.9927 22.8165 27.7697C23.0597 26.5468 23.6601 25.4235 24.5418 24.5418C25.4235 23.6601 26.5468 23.0597 27.7697 22.8165C28.9927 22.5732 30.2603 22.698 31.4122 23.1752C32.5642 23.6524 33.5488 24.4604 34.2415 25.4972C34.9343 26.5339 35.304 27.7528 35.304 28.9997C35.302 30.6711 34.6372 32.2734 33.4553 33.4553C32.2734 34.6372 30.6711 35.302 28.9997 35.304Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 35.304C27.7528 35.304 26.5339 34.9343 25.4972 34.2415C24.4604 33.5488 23.6524 32.5642 23.1752 31.4122C22.698 30.2603 22.5732 28.9927 22.8165 27.7697C23.0597 26.5468 23.6601 25.4235 24.5418 24.5418C25.4235 23.6601 26.5468 23.0597 27.7697 22.8165C28.9927 22.5732 30.2603 22.698 31.4122 23.1752C32.5642 23.6524 33.5488 24.4604 34.2415 25.4972C34.9343 26.5339 35.304 27.7528 35.304 28.9997C35.302 30.6711 34.6372 32.2734 33.4553 33.4553C32.2734 34.6372 30.6711 35.302 28.9997 35.304Z",
    fill: "url(#paint1_linear_743_3988)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8672 23.3066C28.993 23.0827 30.1602 23.1975 31.2207 23.6367C32.2813 24.076 33.1884 24.8209 33.8262 25.7754C34.424 26.6703 34.7601 27.7125 34.7998 28.7852L34.8037 29C34.8016 30.5387 34.1896 32.0135 33.1016 33.1016C32.0133 34.1898 30.538 34.8009 28.999 34.8027C27.8514 34.8026 26.7296 34.4636 25.7754 33.8262C24.8209 33.1884 24.076 32.2813 23.6367 31.2207C23.1975 30.1602 23.0827 28.993 23.3066 27.8672C23.5306 26.7413 24.0838 25.7072 24.8955 24.8955C25.7072 24.0838 26.7413 23.5306 27.8672 23.3066Z",
    stroke: "url(#paint2_linear_743_3988)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 30.8691,
    y: -0.652344,
    width: 36.6086,
    height: 36.6089
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_743_3988_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_743_3988)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1735 23.9564C52.6553 23.9564 55.4778 21.1338 55.4778 17.652C55.4778 14.1702 52.6553 11.3477 49.1735 11.3477C45.6917 11.3477 42.8691 14.1702 42.8691 17.652C42.8691 21.1338 45.6917 23.9564 49.1735 23.9564Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1735 23.9564C52.6553 23.9564 55.4778 21.1338 55.4778 17.652C55.4778 14.1702 52.6553 11.3477 49.1735 11.3477C45.6917 11.3477 42.8691 14.1702 42.8691 17.652C42.8691 21.1338 45.6917 23.9564 49.1735 23.9564Z",
    fill: "url(#paint3_linear_743_3988)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1738 11.8477C52.3793 11.8478 54.9775 14.4468 54.9775 17.6523C54.9774 20.8577 52.3792 23.4559 49.1738 23.4561C45.9683 23.4561 43.3693 20.8578 43.3691 17.6523C43.3691 14.4467 45.9682 11.8477 49.1738 11.8477Z",
    stroke: "url(#paint4_linear_743_3988)",
    strokeOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_743_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.174 41.608C48.8396 41.608 48.5188 41.4752 48.2824 41.2387C48.0459 41.0023 47.9131 40.6816 47.9131 40.3471V17.6515C47.9131 17.3171 48.0459 16.9964 48.2824 16.7599C48.5188 16.5235 48.8396 16.3906 49.174 16.3906C49.5084 16.3906 49.8291 16.5235 50.0655 16.7599C50.302 16.9964 50.4348 17.3171 50.4348 17.6515V40.3471C50.4348 40.6816 50.302 41.0023 50.0655 41.2387C49.8291 41.4752 49.5084 41.608 49.174 41.608Z",
    fill: "url(#paint5_linear_743_3988)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 30.8691,
    y: 22.043,
    width: 36.6086,
    height: 36.6089
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_2_743_3988_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_743_3988)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1735 46.6517C52.6553 46.6517 55.4778 43.8291 55.4778 40.3473C55.4778 36.8655 52.6553 34.043 49.1735 34.043C45.6917 34.043 42.8691 36.8655 42.8691 40.3473C42.8691 43.8291 45.6917 46.6517 49.1735 46.6517Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1735 46.6517C52.6553 46.6517 55.4778 43.8291 55.4778 40.3473C55.4778 36.8655 52.6553 34.043 49.1735 34.043C45.6917 34.043 42.8691 36.8655 42.8691 40.3473C42.8691 43.8291 45.6917 46.6517 49.1735 46.6517Z",
    fill: "url(#paint6_linear_743_3988)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1738 34.543C52.3793 34.5432 54.9775 37.1421 54.9775 40.3477C54.9774 43.553 52.3792 46.1512 49.1738 46.1514C45.9683 46.1514 43.3693 43.5532 43.3691 40.3477C43.3691 37.142 45.9682 34.543 49.1738 34.543Z",
    stroke: "url(#paint7_linear_743_3988)",
    strokeOpacity: 0.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_743_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 52.957C28.7212 52.9569 28.4504 52.8646 28.2298 52.6944C28.0093 52.5242 27.8513 52.2857 27.7806 52.0162C27.7098 51.7467 27.7304 51.4614 27.8389 51.2048C27.9475 50.9482 28.138 50.7348 28.3807 50.5979L48.5546 39.2501C48.8448 39.1001 49.1819 39.0686 49.4948 39.1623C49.8078 39.2559 50.0722 39.4673 50.2323 39.752C50.3925 40.0367 50.4359 40.3725 50.3535 40.6885C50.271 41.0046 50.0691 41.2764 49.7902 41.4465L29.6163 52.7944C29.4285 52.9013 29.2159 52.9573 28.9998 52.957Z",
    fill: "url(#paint8_linear_743_3988)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 10.6953,
    y: 33.3906,
    width: 36.6086,
    height: 36.6089
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_3_743_3988_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_743_3988)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 57.9993C32.4815 57.9993 35.304 55.1768 35.304 51.695C35.304 48.2132 32.4815 45.3906 28.9997 45.3906C25.5179 45.3906 22.6953 48.2132 22.6953 51.695C22.6953 55.1768 25.5179 57.9993 28.9997 57.9993Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 57.9993C32.4815 57.9993 35.304 55.1768 35.304 51.695C35.304 48.2132 32.4815 45.3906 28.9997 45.3906C25.5179 45.3906 22.6953 48.2132 22.6953 51.695C22.6953 55.1768 25.5179 57.9993 28.9997 57.9993Z",
    fill: "url(#paint9_linear_743_3988)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 45.8906C32.2055 45.8908 34.8037 48.4898 34.8037 51.6953C34.8035 54.9007 32.2054 57.4988 29 57.499C25.7945 57.499 23.1955 54.9008 23.1953 51.6953C23.1953 48.4897 25.7943 45.8906 29 45.8906Z",
    stroke: "url(#paint10_linear_743_3988)",
    strokeOpacity: 0.1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_743_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.999 52.957C28.7829 52.9573 28.5703 52.9013 28.3825 52.7944L8.20855 41.4465C7.92971 41.2764 7.7278 41.0046 7.64533 40.6885C7.56287 40.3725 7.60629 40.0367 7.76645 39.752C7.92662 39.4673 8.19102 39.2559 8.50397 39.1623C8.81692 39.0686 9.154 39.1001 9.4442 39.2501L29.6181 50.5979C29.8608 50.7348 30.0513 50.9482 30.1599 51.2048C30.2684 51.4614 30.289 51.7467 30.2182 52.0162C30.1475 52.2857 29.9895 52.5242 29.769 52.6944C29.5484 52.8646 29.2776 52.9569 28.999 52.957Z",
    fill: "url(#paint11_linear_743_3988)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -9.47852,
    y: 22.043,
    width: 36.6086,
    height: 36.6089
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_4_743_3988_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_743_3988)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82583 46.6517C12.3076 46.6517 15.1302 43.8291 15.1302 40.3473C15.1302 36.8655 12.3076 34.043 8.82583 34.043C5.34404 34.043 2.52148 36.8655 2.52148 40.3473C2.52148 43.8291 5.34404 46.6517 8.82583 46.6517Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82583 46.6517C12.3076 46.6517 15.1302 43.8291 15.1302 40.3473C15.1302 36.8655 12.3076 34.043 8.82583 34.043C5.34404 34.043 2.52148 36.8655 2.52148 40.3473C2.52148 43.8291 5.34404 46.6517 8.82583 46.6517Z",
    fill: "url(#paint12_linear_743_3988)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82617 34.543C12.0317 34.5432 14.6299 37.1421 14.6299 40.3477C14.6297 43.553 12.0316 46.1512 8.82617 46.1514C5.62063 46.1514 3.02167 43.5532 3.02148 40.3477C3.02148 37.142 5.62052 34.543 8.82617 34.543Z",
    stroke: "url(#paint13_linear_743_3988)",
    strokeOpacity: 0.1
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_743_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8263 41.608C8.4919 41.608 8.17119 41.4752 7.93473 41.2387C7.69827 41.0023 7.56543 40.6816 7.56543 40.3471V17.6515C7.56543 17.3171 7.69827 16.9964 7.93473 16.7599C8.17119 16.5235 8.4919 16.3906 8.8263 16.3906C9.1607 16.3906 9.48141 16.5235 9.71787 16.7599C9.95433 16.9964 10.0872 17.3171 10.0872 17.6515V40.3471C10.0872 40.6816 9.95433 41.0023 9.71787 41.2387C9.48141 41.4752 9.1607 41.608 8.8263 41.608Z",
    fill: "url(#paint14_linear_743_3988)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -9.47852,
    y: -0.652344,
    width: 36.6086,
    height: 36.6089
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_5_743_3988_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_743_3988)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82583 23.9564C12.3076 23.9564 15.1302 21.1338 15.1302 17.652C15.1302 14.1702 12.3076 11.3477 8.82583 11.3477C5.34404 11.3477 2.52148 14.1702 2.52148 17.652C2.52148 21.1338 5.34404 23.9564 8.82583 23.9564Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82583 23.9564C12.3076 23.9564 15.1302 21.1338 15.1302 17.652C15.1302 14.1702 12.3076 11.3477 8.82583 11.3477C5.34404 11.3477 2.52148 14.1702 2.52148 17.652C2.52148 21.1338 5.34404 23.9564 8.82583 23.9564Z",
    fill: "url(#paint15_linear_743_3988)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82617 11.8477C12.0317 11.8478 14.6299 14.4468 14.6299 17.6523C14.6297 20.8577 12.0316 23.4559 8.82617 23.4561C5.62063 23.4561 3.02167 20.8578 3.02148 17.6523C3.02148 14.4467 5.62052 11.8477 8.82617 11.8477Z",
    stroke: "url(#paint16_linear_743_3988)",
    strokeOpacity: 0.1
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_743_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82594 18.913C8.54733 18.9129 8.27659 18.8205 8.05601 18.6503C7.83544 18.4801 7.67745 18.2417 7.60673 17.9722C7.536 17.7027 7.55653 17.4174 7.66511 17.1608C7.77368 16.9042 7.96418 16.6908 8.20686 16.5539L28.3808 5.20607C28.5253 5.11786 28.6862 5.05966 28.8537 5.03497C29.0212 5.01027 29.192 5.01957 29.3559 5.06232C29.5198 5.10507 29.6733 5.1804 29.8074 5.28379C29.9416 5.38719 30.0535 5.51655 30.1365 5.66414C30.2195 5.81173 30.272 5.97454 30.2907 6.14284C30.3095 6.31115 30.2941 6.48151 30.2456 6.64375C30.197 6.80599 30.1163 6.95679 30.0082 7.08715C29.9001 7.21751 29.7669 7.32476 29.6164 7.40251L9.44251 18.7503C9.25462 18.8572 9.04211 18.9133 8.82594 18.913Z",
    fill: "url(#paint17_linear_743_3988)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 10.6953,
    y: -12,
    width: 36.6086,
    height: 36.6089
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_6_743_3988_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_743_3988)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 12.6087C32.4815 12.6087 35.304 9.78614 35.304 6.30435C35.304 2.82255 32.4815 0 28.9997 0C25.5179 0 22.6953 2.82255 22.6953 6.30435C22.6953 9.78614 25.5179 12.6087 28.9997 12.6087Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 12.6087C32.4815 12.6087 35.304 9.78614 35.304 6.30435C35.304 2.82255 32.4815 0 28.9997 0C25.5179 0 22.6953 2.82255 22.6953 6.30435C22.6953 9.78614 25.5179 12.6087 28.9997 12.6087Z",
    fill: "url(#paint18_linear_743_3988)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 0.5C32.2055 0.500183 34.8037 3.09915 34.8037 6.30469C34.8035 9.51007 32.2054 12.1082 29 12.1084C25.7945 12.1084 23.1955 9.51018 23.1953 6.30469C23.1953 3.09903 25.7943 0.5 29 0.5Z",
    stroke: "url(#paint19_linear_743_3988)",
    strokeOpacity: 0.1
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_743_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.432 13.5402L29.618 5.20712C29.3278 5.05716 28.9908 5.02568 28.6778 5.11931C28.3648 5.21294 28.1004 5.42436 27.9403 5.70906C27.7801 5.99376 27.7367 6.3295 27.8192 6.64558C27.9016 6.96166 28.1035 7.23339 28.3824 7.40356L43.1976 15.7379C43.4555 14.9291 43.8755 14.1813 44.432 13.5402Z",
    fill: "url(#paint20_linear_743_3988)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_743_3988",
    x: 7.56738,
    y: 5.04297,
    width: 42.8677,
    height: 49.9131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_743_3988",
    x: 10.6953,
    y: 10.6953,
    width: 36.6086,
    height: 36.6089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_743_3988_clip_path",
    transform: "translate(-10.6953 -10.6953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 35.304C27.7528 35.304 26.5339 34.9343 25.4972 34.2415C24.4604 33.5488 23.6524 32.5642 23.1752 31.4122C22.698 30.2603 22.5732 28.9927 22.8165 27.7697C23.0597 26.5468 23.6601 25.4235 24.5418 24.5418C25.4235 23.6601 26.5468 23.0597 27.7697 22.8165C28.9927 22.5732 30.2603 22.698 31.4122 23.1752C32.5642 23.6524 33.5488 24.4604 34.2415 25.4972C34.9343 26.5339 35.304 27.7528 35.304 28.9997C35.302 30.6711 34.6372 32.2734 33.4553 33.4553C32.2734 34.6372 30.6711 35.302 28.9997 35.304Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_743_3988",
    x: 30.8691,
    y: -0.652344,
    width: 36.6086,
    height: 36.6089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_743_3988_clip_path",
    transform: "translate(-30.8691 0.652344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1735 23.9564C52.6553 23.9564 55.4778 21.1338 55.4778 17.652C55.4778 14.1702 52.6553 11.3477 49.1735 11.3477C45.6917 11.3477 42.8691 14.1702 42.8691 17.652C42.8691 21.1338 45.6917 23.9564 49.1735 23.9564Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_743_3988",
    x: 47.9131,
    y: 16.3906,
    width: 2.52173,
    height: 27.2173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_743_3988",
    x: 30.8691,
    y: 22.043,
    width: 36.6086,
    height: 36.6089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_743_3988_clip_path",
    transform: "translate(-30.8691 -22.043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1735 46.6517C52.6553 46.6517 55.4778 43.8291 55.4778 40.3473C55.4778 36.8655 52.6553 34.043 49.1735 34.043C45.6917 34.043 42.8691 36.8655 42.8691 40.3473C42.8691 43.8291 45.6917 46.6517 49.1735 46.6517Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_743_3988",
    x: 27.7393,
    y: 39.1094,
    width: 22.655,
    height: 15.8477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_743_3988",
    x: 10.6953,
    y: 33.3906,
    width: 36.6086,
    height: 36.6089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_743_3988_clip_path",
    transform: "translate(-10.6953 -33.3906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 57.9993C32.4815 57.9993 35.304 55.1768 35.304 51.695C35.304 48.2132 32.4815 45.3906 28.9997 45.3906C25.5179 45.3906 22.6953 48.2132 22.6953 51.695C22.6953 55.1768 25.5179 57.9993 28.9997 57.9993Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_743_3988",
    x: 7.60449,
    y: 39.1094,
    width: 22.655,
    height: 15.8477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_743_3988",
    x: -9.47852,
    y: 22.043,
    width: 36.6086,
    height: 36.6089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_743_3988_clip_path",
    transform: "translate(9.47852 -22.043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82583 46.6517C12.3076 46.6517 15.1302 43.8291 15.1302 40.3473C15.1302 36.8655 12.3076 34.043 8.82583 34.043C5.34404 34.043 2.52148 36.8655 2.52148 40.3473C2.52148 43.8291 5.34404 46.6517 8.82583 46.6517Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_743_3988",
    x: 7.56543,
    y: 16.3906,
    width: 2.52173,
    height: 27.2173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_743_3988",
    x: -9.47852,
    y: -0.652344,
    width: 36.6086,
    height: 36.6089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_5_743_3988_clip_path",
    transform: "translate(9.47852 0.652344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82583 23.9564C12.3076 23.9564 15.1302 21.1338 15.1302 17.652C15.1302 14.1702 12.3076 11.3477 8.82583 11.3477C5.34404 11.3477 2.52148 14.1702 2.52148 17.652C2.52148 21.1338 5.34404 23.9564 8.82583 23.9564Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_743_3988",
    x: 7.56543,
    y: 5.02148,
    width: 22.7329,
    height: 15.8916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_743_3988",
    x: 10.6953,
    y: -12,
    width: 36.6086,
    height: 36.6089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_6_743_3988_clip_path",
    transform: "translate(-10.6953 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9997 12.6087C32.4815 12.6087 35.304 9.78614 35.304 6.30435C35.304 2.82255 32.4815 0 28.9997 0C25.5179 0 22.6953 2.82255 22.6953 6.30435C22.6953 9.78614 25.5179 12.6087 28.9997 12.6087Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_743_3988",
    x: 27.7783,
    y: 5.06641,
    width: 16.6536,
    height: 12.6714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3988"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3988",
    x1: 7.56738,
    y1: 5.04297,
    x2: 58.6818,
    y2: 16.6551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3988",
    x1: 22.6953,
    y1: 22.6953,
    x2: 37.548,
    y2: 26.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3988",
    x1: 23.0893,
    y1: 23.2684,
    x2: 35.304,
    y2: 23.2684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3988",
    x1: 42.8691,
    y1: 11.3477,
    x2: 57.7218,
    y2: 15.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_743_3988",
    x1: 43.2632,
    y1: 11.9208,
    x2: 55.4778,
    y2: 11.9208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_743_3988",
    x1: 47.9131,
    y1: 16.3906,
    x2: 51.0731,
    y2: 16.4709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_743_3988",
    x1: 42.8691,
    y1: 34.043,
    x2: 57.7218,
    y2: 37.8143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_743_3988",
    x1: 43.2632,
    y1: 34.6161,
    x2: 55.4778,
    y2: 34.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_743_3988",
    x1: 27.7393,
    y1: 39.1094,
    x2: 51.966,
    y2: 49.1736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_743_3988",
    x1: 22.6953,
    y1: 45.3906,
    x2: 37.548,
    y2: 49.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_743_3988",
    x1: 23.0893,
    y1: 45.9637,
    x2: 35.304,
    y2: 45.9637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_743_3988",
    x1: 7.60449,
    y1: 39.1094,
    x2: 31.8312,
    y2: 49.1736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_743_3988",
    x1: 2.52148,
    y1: 34.043,
    x2: 17.3741,
    y2: 37.8143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_743_3988",
    x1: 2.91551,
    y1: 34.6161,
    x2: 15.1302,
    y2: 34.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_743_3988",
    x1: 7.56543,
    y1: 16.3906,
    x2: 10.7254,
    y2: 16.4709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_743_3988",
    x1: 2.52148,
    y1: 11.3477,
    x2: 17.3741,
    y2: 15.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_743_3988",
    x1: 2.91551,
    y1: 11.9208,
    x2: 15.1302,
    y2: 11.9208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_743_3988",
    x1: 7.56543,
    y1: 5.02148,
    x2: 31.8736,
    y2: 15.1223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_743_3988",
    x1: 22.6953,
    y1: 0,
    x2: 37.548,
    y2: 3.77137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_743_3988",
    x1: 23.0893,
    y1: 0.573123,
    x2: 35.304,
    y2: 0.573123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_743_3988",
    x1: 27.7783,
    y1: 5.06641,
    x2: 45.8267,
    y2: 12.2182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon03);
export default __webpack_public_path__ + "static/media/feature-icon03.b43b701182c3cea22c014485a37562f3.svg";
export { ForwardRef as ReactComponent };